<div style="display: flex">
    <p-dialog header="Upload Excel File" [(visible)]="showUploadDialog" [maximizable]="false"
        [style]="{ width: '35vw', height: '47vh' }">
        <div class="grid">
            <div class="col-12">
                <div class="grid">
                    <span class="col-12">
                        Steps for uploading a budget worksheet:
                    </span>
                    <span class="col-12">
                        1. Download the budget data entry worksheet
                    </span>
                    <span class="col-12">
                        2. Update the worksheet with the budget in Excel
                    </span>
                    <span class="col-12"> 3. Save the worksheet </span>
                    <span class="col-12">
                        4. Upload the completed Excel worksheet on eFAACT
                        Central - Project Budgets process
                    </span>
                    <!-- <span class="col-12">
                        5. Once reviewed, commit the cumulatives to apply them
                    </span> -->
                </div>
            </div>
            <div class="col-12">
                <div class="grid flex">
                    <div class="col-12 justify-content-center text-center" style="
                            margin-top: 1em;
                            padding: 2em;
                            border: 2px dashed grey;
                            background-color: #f0f0f0;
                        ">
                        <label for="file-upload" class="ef-file-upload">
                            <i class="pi pi-file-excel" style="color: black; padding-right: 0.25em"></i>
                            Browse...
                        </label>
                        <span id="file-selected" style="padding-left: 1em"></span>
                        <input #fileUpload id="file-upload" type="file" accept=".xls, .xlsx"
                            (change)="uploadExcelFile($event)" />

                        <p-message *ngIf="this.showUploadError" severity="error"
                            text="Please select a file first"></p-message>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #footer>
            <button type="button" pButton icon="pi pi-upload" (click)="sendJSON()" label="Upload"
                class="p-button-text p-button-primary"></button>
            <button type="button" pButton (click)="this.showUploadDialog = false" icon="pi pi-times" label="Cancel"
                class="p-button-text p-button-danger"></button>
        </ng-template>
    </p-dialog>
</div>

<p-dialog header="Table Display Options" [(visible)]="showOptions" [maximizable]="false" [style]="{ width: '25vw' }">
        <div class="flex items-center mt-3 mb-3">
            <p-checkbox binary="true" inputId="showDisbursment" [(ngModel)]="showDisbursment"
                [disabled]="disabled"></p-checkbox>
            <label class="ml-1">Show Disburse Option</label>
        </div>
        <div class="flex items-center mb-3">
            <p-checkbox binary="true" inputId="showPeriodTotal" [(ngModel)]="showPeriodTotal"
                [disabled]="disabled"></p-checkbox>
            <label class="ml-1">Show Total</label>
        </div>
        <div class="flex items-center mb-3">
            <p-checkbox binary="true" inputId="showhideAmount" [(ngModel)]="showAmounts"
                (ngModelChange)="showAmountsChanged()" [disabled]="disabled"></p-checkbox>

            <label class="ml-1">Show Amounts</label>
        </div>
        <div class="flex items-center mb-3">
            <p-checkbox binary="true" inputId="showhidePerson" [(ngModel)]="showPerson"
                [disabled]="disabled"></p-checkbox>
            <label class="ml-1">Show Person</label>
        </div>
        <div class="flex items-center mb-3">
            <p-checkbox binary="true" inputId="showActuals" [(ngModel)]="showActuals"
                (ngModelChange)="showActualsChanged()" [disabled]="disabled"></p-checkbox>
            <label class="ml-1">Show Actuals</label>
        </div>
        <div class="flex items-center mb-3">
            <p-checkbox binary="true" inputId="showEmptyBudgets" [(ngModel)]="showEmptyBudgets"
                (ngModelChange)="showEmptyBudgetsChange()" [disabled]="disabled"></p-checkbox>
            <label class="ml-1">Show Empty Budgets</label>
        </div>
</p-dialog>

<p-dialog header="Update Budget" [(visible)]="showUpdateBudgetDialog" [maximizable]="false" [style]="{ width: '30vw' }" [modal]="false">
    <form [formGroup]="updateBudgetForm">
        <div class="grid">
            <div class="col-12">
                <p-floatLabel variant="on" class="mt-2">
                    <p-select
                        fluid
                        id="updateTask"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [autoDisplayFirst]="false"
                        [options]="tasks"
                        [filter]="true"
                        appendTo="body"
                        formControlName="TaskListID"
                        [disabled]="true">
                    </p-select>
                    <label>Task</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <p-select
                        fluid
                        id="updateCostType"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [autoDisplayFirst]="false"
                        [options]="costTypes"
                        [filter]="true"
                        appendTo="body"
                        formControlName="CostType"
                        [disabled]="true">
                    </p-select>
                    <label>Cost Type</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <p-select
                        fluid
                        id="updateServiceItem"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [autoDisplayFirst]="false"
                        [options]="serviceItems"
                        [filter]="true"
                        appendTo="body"
                        formControlName="SIListID"
                        [disabled]="true">
                    </p-select>
                    <label>Item</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <p-select
                        fluid
                        id="updatePerson"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [autoDisplayFirst]="false"
                        [options]="directReports"
                        [filter]="true"
                        appendTo="body"
                        formControlName="PersonListID"
                        [disabled]="true">
                    </p-select>
                    <label>Employee/Consultants</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <p-select
                        fluid
                        id="updatePayrollItem"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [autoDisplayFirst]="false"
                        [options]="payrollItems"
                        [filter]="true"
                        appendTo="body"
                        formControlName="PIListID"
                        [disabled]="true">
                    </p-select>
                    <label>Payroll Item</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <p-select
                        fluid
                        id="updateCostCenter"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [autoDisplayFirst]="false"
                        [options]="costCenters"
                        [filter]="true"
                        appendTo="body"
                        formControlName="CostCenterID"
                        [disabled]="true">
                    </p-select>
                    <label>Cost Center</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <p-multiselect
                        fluid
                        id="updatePeriod"
                        [virtualScroll]="true"
                        [itemSize]="dropdownItemHeight"
                        [options]="periodOptions"
                        optionLabel="label"
                        optionValue="value"
                        [filter]="true"
                        appendTo="body"
                        formControlName="Periods"
                        selectedItemsLabel="{0} Period(s) selected">
                    </p-multiselect>
                    <label>Period</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <input
                        fluid
                        id="updateHours"
                        pInputText
                        type="number"
                        formControlName="Hours"
                        step="0.01">
                    <label>Hours</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <p-floatLabel variant="on">
                    <input
                        fluid
                        id="updateAmount"
                        pInputText
                        type="number"
                        formControlName="Amount"
                        step="0.01">
                    <label>Amount</label>
                </p-floatLabel>
            </div>
            <div class="col-12">
                <div class="flex items-center mt-2 mb-2">
                    <p-checkbox
                        binary="true"
                        inputId="updateDisburse"
                        formControlName="Disburse"
                        [disabled]="disabled">
                    </p-checkbox>
                    <label class="ml-1" for="updateDisburse">Disburse across selected periods</label>
                </div>
            </div>
        </div>
    </form>
    <ng-template #footer>
        <button
            pButton
            label="Cancel"
            icon="pi pi-times"
            (click)="onUpdateBudgetCancel()"
            class="p-button-text p-button-danger">
        </button>
        <button
            pButton
            label="Save"
            icon="pi pi-check"
            (click)="onUpdateBudgetSave()"
            class="p-button-text p-button-success"
            [disabled]="updateBudgetForm.invalid">
        </button>
    </ng-template>
</p-dialog>

<p-toolbar>
    <form [formGroup]="budgetForm">
        <div class="flex gap-1">
            <p-floatLabel variant="on">
                <p-datepicker #budgetStartDate inputId="budgetStartDate" formControlName="StartDate" appendTo="body"
                    selectionMode="single" [readonlyInput]="false" dateFormat="mm/dd/yy" [monthNavigator]="true"
                    [yearNavigator]="true" [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "></p-datepicker>
                <label for="budgetStartDate">Budget Start Date</label>
            </p-floatLabel>

            <p-floatLabel variant="on">
                <p-datepicker #budgetEndDate [disabled]="!budgetStartDate.value" inputId="budgetEndDate"
                    formControlName="EndDate" appendTo="body" selectionMode="single" [readonlyInput]="false"
                    dateFormat="mm/dd/yy" [maxDate]="maxBudgetDate" [monthNavigator]="true" [yearNavigator]="true"
                    [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "></p-datepicker>
                <label for="budgetEndDate">Budget End Date</label>
            </p-floatLabel>
        </div>
    </form>
    <p-button pRipple severity="primary" icon="pi pi-plus-circle" label="Add Budget" [title]="
        moment(budgetEndDate?.value).isAfter(
            contract?.BudgetEndDate
        )
            ? 'Budget End Date cannot be after Contract Budget End Date'
            : 'Add Budget'
    " [disabled]="
        !(contract?.Budgetlevelid && contract?.Budgetcycleid) ||
        budgetForm.invalid ||
        moment(budgetEndDate?.value).isAfter(
            contract?.BudgetEndDate
        ) ||
        disabled
    " (onClick)="Add.next()"></p-button>
    <p-button [attr.title]="
        'Convert current FY employee authorizations into a budget'
    " id="jumpstart" pRipple severity="primary" label="Jumpstart Budget" [disabled]="
        contract?.Budgetlevelid !== 1 ||
        contract.ActiveAuthCnt <= 0 ||
        budgetForm.invalid ||
        disabled
    " title="Convert current FY authorizations into a budget" (onClick)="onJumpstart()"></p-button>
    <p-button id="update-budget" [disabled]="
        !dataTable.selection ||
        (dataTable.selection && dataTable.selection.length !== 1) ||
        disabled
    " pRipple severity="primary" icon="pi pi-pencil" label="Update Budget" title="Update Budget"
        (onClick)="showUpdateBudgetDialog = true; onUpdateBudgetDialogOpen()" title="Select a single row to update budget details."></p-button>
    <p-button id="multi-delete" [hidden]="showUpdateBudgetDialog" [disabled]="
        !dataTable.selection ||
        (dataTable.selection && dataTable.selection.length < 1) ||
        disabled
    " pRipple styleClass="p-button-danger" icon="pi pi-trash" label="Delete" title="Delete"
        (onClick)="onRowEditDelete(dataTable.selection)"></p-button>
    <p-splitButton *featureFlag="'projectBudgetDownload'" id="download-csv" icon="pi pi-download"
        pTooltip="Download" styleClass="p-button-secondary" [model]="this.downloadOptions"
        [disabled]="budgetForm.invalid || disabled"></p-splitButton>

    <div class="flex items-center" title="Auto Calculate overrides dollar entries when applicable.">
        <p-checkbox class="ml-2" #autoCalc [disabled]="disabled" binary="true"
            [formControl]="budgetForm.controls['AutoCalculateAmount']" (onChange)="onAutoCalcChange($event)"
            data-toggle="tooltip" data-placement="top"></p-checkbox>
        <label class="ml-1">Auto Calculate Amount</label>
    </div>

    <button pButton pRipple severity="secondary" label="Display Options" icon="pi pi-external-link" (click)="showOptions = true;"></button>

    <!-- <div class="grid ml-2">
        <div class="col-4">
            <div class="flex items-center">
                <p-checkbox binary="true" inputId="showDisbursment" [(ngModel)]="showDisbursment"
                    [disabled]="disabled"></p-checkbox>
                <label class="ml-1">Show Disburse Option</label>
            </div>
        </div>
        <div class="col-4">
            <div class="flex items-center">
                <p-checkbox binary="true" inputId="showPeriodTotal" [(ngModel)]="showPeriodTotal"
                    [disabled]="disabled"></p-checkbox>
                <label class="ml-1">Show Total</label>
            </div>
        </div>
        <div class="col-4">
            <div class="flex items-center">
                <p-checkbox binary="true" inputId="showhideAmount" [(ngModel)]="showAmounts"
                    (ngModelChange)="showAmountsChanged()" [disabled]="disabled"></p-checkbox>

                <label class="ml-1">Show Amounts</label>
            </div>
        </div>
        <div class="col-4">
            <div class="flex items-center">
                <p-checkbox binary="true" inputId="showhidePerson" [(ngModel)]="showPerson"
                    [disabled]="disabled"></p-checkbox>
                <label class="ml-1">Show Person</label>
            </div>
        </div>
        <div class="col-4">
            <div class="flex items-center">
                <p-checkbox binary="true" inputId="showActuals" [(ngModel)]="showActuals"
                    (ngModelChange)="showActualsChanged()" [disabled]="disabled"></p-checkbox>
                <label class="ml-1">Show Actuals</label>
            </div>
        </div>
        <div class="col-4">
            <div class="flex items-center">
                <p-checkbox binary="true" inputId="showEmptyBudgets" [(ngModel)]="showEmptyBudgets"
                    (ngModelChange)="showEmptyBudgetsChange()" [disabled]="disabled"></p-checkbox>
                <label class="ml-1">Show Empty Budgets</label>
            </div>
        </div>
    </div> -->

    <!-- <div style="
        height: 6em;
        width: 25em;
        padding: 0;
        margin: 0;
        margin-top: -0.5em;
        margin-bottom: -0.5em;
        overflow: visible;
    ">
        <div class="display-options">
            <p>
                <span class="p-float-label">
                    <p-checkbox binary="true" inputId="showDisbursment" [(ngModel)]="showDisbursment"
                        [disabled]="disabled"></p-checkbox>
                    <label>Show Disburse Option</label>
                </span>
            </p>
            <p>
                <span class="p-float-label">
                    <p-checkbox binary="true" inputId="showPeriodTotal" [(ngModel)]="showPeriodTotal"
                        [disabled]="disabled"></p-checkbox>
                    <label>Show Total</label>
                </span>
            </p>
            <p *ngIf="false">
                <span class="p-float-label">
                    <p-checkbox binary="true" inputId="showhideAmount" [(ngModel)]="showAmounts"
                        (ngModelChange)="showAmountsChanged()" [disabled]="disabled"></p-checkbox>

                    <label>Show Amounts</label>
                </span>
            </p>
            <p>
                <span class="p-float-label">
                    <p-checkbox binary="true" inputId="showhidePerson" [(ngModel)]="showPerson"
                        [disabled]="disabled"></p-checkbox>
                    <label>Show Person</label>
                </span>
            </p>
            <p>
                <span class="p-float-label">
                    <p-checkbox binary="true" inputId="showActuals" [(ngModel)]="showActuals"
                        (ngModelChange)="showActualsChanged()" [disabled]="disabled"></p-checkbox>
                    <label>Show Actuals</label>
                </span>
            </p>
            <p style="
                height: 0em;
                flex-basis: 0em;
                border-bottom: 1px solid #999;
                width: 13em;
                margin-bottom: 0.75em;
                margin-top: 0.75em;
            "></p>
            <p>
                <span class="p-float-label">
                    <p-checkbox binary="true" inputId="showEmptyBudgets" [(ngModel)]="showEmptyBudgets"
                        (ngModelChange)="showEmptyBudgetsChange()" [disabled]="disabled"></p-checkbox>
                    <label>Show Empty Budgets</label>
                </span>
            </p>
        </div>
    </div> -->
</p-toolbar>
<p-table stripedRows #dataTable [value]="filteredItems" dataKey="id" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
    [(selection)]="selected" [scrollable]="true" [scrollHeight]="tableScrollHeight" [columns]="cols"
    exportFilename="budget" [exportFunction]="onExport" responsiveLayout="scroll">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols + numFrozenCols" style="text-align: center">
                <div>
                    <span> No budgets available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols + numFrozenCols" style="text-align: center">
                <div>
                    Loading...
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item let-columns>
        <tr>
            <!-- INDICATORS -->
            <th class="colgroup" pFrozenColumn [frozen]="IsColumnFrozen" colspan="2"></th>
            <!-- BUDGET -->
            <th class="colgroup"
                colspan="3">
                BUDGET
            </th>
            <!-- ? Person, PI, Cost Center -->
            <th class="colgroup" colspan="3" [hidden]="!showPerson">
                PERSON
            </th>
            <!-- DISBURSEMENT -->
            <th class="colgroup" colspan="3" [hidden]="!showDisbursment">
                DISBURSE
            </th>
            <!-- TOTALS -->
            <th class="colgroup" [attr.colspan]="showAmounts ? 2 : 1" [hidden]="!showPeriodTotal">
                PERIOD TOTAL
            </th>
            <!-- dynamic -->
            <th class="colgroup" *ngFor="let col of colGroups" [attr.colspan]="col.colspan">
                {{ col.header | uppercase }}
            </th>
        </tr>
        <tr>
            <!-- INDICATORS -->
            <!-- Selection -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" class="select-cell ">
                <p-tableHeaderCheckbox *ngIf="!editing && !showUpdateBudgetDialog"></p-tableHeaderCheckbox>
            </th>
            <!-- delete Button -->
            <th class=" delete-cell" pFrozenColumn [frozen]="IsColumnFrozen"></th>
            <!-- BUDGET -->
            <!-- Task -->
            <th pSortableColumn="TaskLongName">
                Task
                <p-sortIcon field="TaskLongName" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Cost Type -->
            <th pSortableColumn="CostType">
                Cost Type
                <p-sortIcon field="CostType" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Service Item -->
            <th pSortableColumn="ServiceItem">
                Service Item
                <p-sortIcon field="ServiceItem" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Person -->
            <th pSortableColumn="PersonName" [hidden]="!showPerson">
                Person
                <p-sortIcon field="PersonName" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Payroll Item -->
            <th pSortableColumn="PayrollItem" [hidden]="!showPerson">
                Payroll Item
                <p-sortIcon field="PayrollItem" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Cost Center -->
            <th pSortableColumn="CostCenterDesc" [hidden]="!showPerson">
                Cost Center
                <p-sortIcon field="CostCenterDesc" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- DISBURSEMENT -->
            <!-- Disburse Hours -->
            <th [hidden]="!showDisbursment">
                Hours
            </th>
            <!-- Disburse $ -->
            <th [hidden]="!showDisbursment">
                $
            </th>
            <!-- Disburse Button -->
            <th [hidden]="!showDisbursment" class="delete-cell">
                <i class="fas fa-arrows-alt" title="Disburse"></i>
            </th>
            <!-- TOTALS -->
            <!-- Period Hours -->
            <th class=" edit-cell" [hidden]="!showPeriodTotal">
                Hours
            </th>
            <!-- Period $ -->
            <th class=" edit-cell" [hidden]="!showPeriodTotal || !showAmounts">
                Amount
            </th>
            <!-- dynamic -->
            <th *ngFor="let col of columns" [style]="col.style" [hidden]="col.hidden">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex" let-columns="columns">
        <tr [pSelectableRow]="item" data-id="row-{{ item.id }}">
            <!-- INDICATORS -->
            <!-- Selection -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="select-cell">
                <p-tableCheckbox *ngIf="!editing && (!showUpdateBudgetDialog || isRowSelected(item))" [value]="item"></p-tableCheckbox>
            </td>
            <!-- Delete Button -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="delete-cell">
                <button pButton *ngIf="
                                    !disabled &&
                                    !showUpdateBudgetDialog &&
                                    (!editing?.id ||
                                        editing?.id === item?.id) &&
                                    ((selected && selected.length < 2) ||
                                        !selected)
                                " type="button" icon="pi pi-trash"
                    class="p-button-danger p-button-rounded p-button-text" (click)="onRowEditDelete([item])"
                    title="Delete"></button>
            </td>
            <!-- BUDGET -->
            <!-- Task -->
            <td [attr.title]="
                        item.ContractType + ' - ' + item.TaskLongName
                    ">
                {{ item.TaskLongName }}
            </td>
            <!-- Cost Type -->
            <td [attr.title]="item.CostType">
                {{ item.CostType }}
            </td>
            <!-- Service Item -->
            <td [attr.title]="item.ServiceItem">
                {{ item.ServiceItem }}
            </td>
            <!-- Person -->
            <td [attr.title]="item.PersonName" [hidden]="!showPerson">
                {{ item.PersonName }}
            </td>
            <!-- Payroll Item -->
            <td [attr.title]="item.PayrollItem" [hidden]="!showPerson">
                {{ item.PayrollItem }}
            </td>
            <!-- Cost Center -->
            <td [attr.title]="item.CostCenterDesc" [hidden]="!showPerson">
                {{ item.CostCenterDesc }}
            </td>
            <!-- DISBURSEMENT -->
            <!-- Disburse Hours -->
            <td class="hours" [hidden]="!showDisbursment">
                {{ item.DisburseHours }}
            </td>
            <!-- Disburse $ -->
            <td class="currency" [hidden]="!showDisbursment">
                {{ item.DisburseAmount }}
            </td>
            <!-- Disburse Button -->
            <td [hidden]="!showDisbursment" class="delete-cell">
                <button pButton [disabled]="
                                    !(
                                        item.DisburseHours ||
                                        item.DisburseAmount
                                    )
                                " type="button" icon="fas fa-arrows-alt" class="p-button-rounded p-button-text"
                    (click)="disburse(item)" title="Disburse"></button>
            </td>
            <!-- TOTALS -->
            <!-- Period Hours -->
            <td class="disabled hours edit-cell" [hidden]="!showPeriodTotal">
                {{ item.YearlyBudgetHours.toFixed(2) }}
            </td>
            <!-- Period $ -->
            <td class="disabled currency edit-cell" [hidden]="!showPeriodTotal || !showAmounts">
                {{ item.YearlyBudgetAmount | currency }}
            </td>
            <!-- dynamic -->
            <td class="{{ col.field }} {{
                        col.class
                    }}" [ngClass]="{
                        'alert-danger': item[col.group][col.field] < 0,
                        alert: item[col.group][col.field] < 0
                    }" *ngFor="let col of columns" [style]="col.style" [hidden]="col.hidden">
                {{
                    col.field !== 'TxnID' && item[col.group]
                    ? formatBudgetColumn(item, col)
                    : ''
                }}
            </td>
        </tr>
    </ng-template>
</p-table>
